import React from 'react'
import PropTypes from 'prop-types'
import produce from 'immer'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { withNamespaces } from '@edulastic/localization'
import { ComposeQuestion } from '@edulastic/common'

import { ContentArea } from '../../styled/ContentArea'
import Options from './Options'
import { setQuestionDataAction } from '../../../author/QuestionEditor/ducks'
import QuestionMetadata from '../../containers/QuestionMetadata'

const InlineMathEssayEdit = ({
  item,
  setQuestionData,
  t: i18translate,
  fillSections,
  cleanSections,
  advancedLink,
  advancedAreOpen,
  froalaFooter,
}) => {
  const { title, stimulus } = item

  const handleQuestionChange = (prop, uiStyle) => {
    setQuestionData(
      produce(item, (draft) => {
        draft[prop] = uiStyle
      })
    )
  }

  return (
    <ContentArea>
      <ComposeQuestion
        fillQuestionSections={fillSections}
        clearQuestionSections={cleanSections}
        handleQuestionChange={(value) =>
          handleQuestionChange('stimulus', value)
        }
        composeQuestionLabel={i18translate('common.question.composeQuestion')}
        stimulusContent={stimulus}
        itemTitle={title}
        placeholder={i18translate('component.inlineMathEssay.enterQuestion')}
        froalaFooter={froalaFooter}
        toolbarId="compose-question"
      />

      <QuestionMetadata isEditView />

      {advancedLink}

      <Options
        item={item}
        fillSections={fillSections}
        cleanSections={cleanSections}
        setQuestionData={setQuestionData}
        advancedAreOpen={advancedAreOpen}
      />
    </ContentArea>
  )
}

InlineMathEssayEdit.propTypes = {
  item: PropTypes.object.isRequired,
  setQuestionData: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  fillSections: PropTypes.func,
  cleanSections: PropTypes.func,
  advancedLink: PropTypes.any,
  advancedAreOpen: PropTypes.bool,
}

InlineMathEssayEdit.defaultProps = {
  advancedAreOpen: false,
  advancedLink: null,
  fillSections: () => {},
  cleanSections: () => {},
}

const enhance = compose(
  withNamespaces('assessment'),
  connect(({ user }) => ({ user }), { setQuestionData: setQuestionDataAction })
)

export default enhance(InlineMathEssayEdit)
